let persistentAudio = null;

export function getPersistentAudio() {
  if (persistentAudio === null && typeof Audio !== 'undefined') {
    persistentAudio = new Audio();
  }
  return persistentAudio;
}

export function unlockPersistentAudio() {
  const audio = getPersistentAudio();
  if (!audio) return;

  try {
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
        })
        .catch((error) => {
          console.error(
            '[Audio Unlock] Persistent audio unlock failed:',
            error
          );
        });
    }
  } catch (error) {
    console.error('[Audio Unlock] Persistent audio unlock failed:', error);
  }
}
